import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ParticipationTable = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(data?.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data?.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    setCurrentPage(prev => Math.max(1, prev - 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prev => Math.min(totalPages, prev + 1));
  };

  const getModeIcon = (mode) => {
    return mode === 'Autónomo' ? 'User' : 'Users';
  };

  const getModeColor = (mode) => {
    return mode === 'Autónomo' ? 'var(--color-primary)' : 'var(--color-secondary)';
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-md overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">
          Registro de Participaciones
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Historial detallado de todas las participaciones
        </p>
      </div>
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/30">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                ID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Fecha y Hora
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Premio
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Modo
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Participante
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {currentData?.map((record) => (
              <tr key={record?.id} className="hover:bg-muted/20 transition-smooth">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-foreground">
                  #{record?.id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {record?.timestamp}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
                    {record?.prize}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-2">
                    <Icon 
                      name={getModeIcon(record?.mode)} 
                      size={16} 
                      color={getModeColor(record?.mode)} 
                    />
                    <span className="text-sm text-foreground">{record?.mode}</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {record?.participant || 'Anónimo'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="md:hidden divide-y divide-border">
        {currentData?.map((record) => (
          <div key={record?.id} className="p-4 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-foreground">#{record?.id}</span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
                {record?.prize}
              </span>
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Fecha:</span>
                <span className="text-foreground">{record?.timestamp}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Modo:</span>
                <div className="flex items-center gap-2">
                  <Icon 
                    name={getModeIcon(record?.mode)} 
                    size={14} 
                    color={getModeColor(record?.mode)} 
                  />
                  <span className="text-foreground">{record?.mode}</span>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-muted-foreground">Participante:</span>
                <span className="text-foreground">{record?.participant || 'Anónimo'}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 md:p-6 border-t border-border bg-muted/30">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            Mostrando {startIndex + 1} a {Math.min(endIndex, data?.length)} de {data?.length} registros
          </p>
          <div className="flex items-center gap-2">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-border hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed transition-smooth focus-ring"
              aria-label="Página anterior"
            >
              <Icon name="ChevronLeft" size={20} color="var(--color-foreground)" />
            </button>
            <span className="text-sm font-medium text-foreground px-4">
              {currentPage} / {totalPages}
            </span>
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-border hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed transition-smooth focus-ring"
              aria-label="Página siguiente"
            >
              <Icon name="ChevronRight" size={20} color="var(--color-foreground)" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipationTable;